"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_INPUT_HEIGHT = exports.BUTTON_CONTENT_TRANSITION_DURATION = exports.HEADER_DROPDOWN_PADDING_DESKTOP = exports.HEADER_DROPDOWN_PADDING_LAPTOP = exports.HEADER_DROPDOWN_PADDING_TABLET = exports.HEADER_DROPDOWN_PADDING_MOBILE = exports.HEADER_HEIGHT_MOBILE = exports.HEADER_HEIGHT = void 0;
exports.HEADER_HEIGHT = "57px";
exports.HEADER_HEIGHT_MOBILE = "67px";
exports.HEADER_DROPDOWN_PADDING_MOBILE = "15px";
exports.HEADER_DROPDOWN_PADDING_TABLET = "16px";
exports.HEADER_DROPDOWN_PADDING_LAPTOP = "32px";
exports.HEADER_DROPDOWN_PADDING_DESKTOP = "55px";
exports.BUTTON_CONTENT_TRANSITION_DURATION = 0.2;
exports.SEARCH_INPUT_HEIGHT = "40px";
